
import { Component, Emit, Vue } from 'vue-property-decorator';
import AccountBoxOutlineIcon from 'vue-material-design-icons/AccountBoxOutline.vue';
import AccountCircleOutlineIcon from 'vue-material-design-icons/AccountCircleOutline.vue';
import AccountGroupOutlineIcon from 'vue-material-design-icons/AccountGroupOutline.vue';
import BriefcaseOutlineIcon from 'vue-material-design-icons/BriefcaseOutline.vue';
import CalendarOutlineIcon from 'vue-material-design-icons/CalendarOutline.vue';
import CheckboxMarkedCircleOutlineIcon from 'vue-material-design-icons/CheckboxMarkedCircleOutline.vue';
import ClipboardOutlineIcon from 'vue-material-design-icons/ClipboardOutline.vue';
import DollyIcon from 'vue-material-design-icons/Dolly.vue';
import EmailMultipleOutlineIcon from 'vue-material-design-icons/EmailMultipleOutline.vue';
import ShapeOutlineIcon from 'vue-material-design-icons/ShapeOutline.vue';
// import BusinessIcon from 'vue-material-design-icons/Business.vue';
import ClipboardListOutlineIcon from 'vue-material-design-icons/ClipboardListOutline.vue';
import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
import BaseListHeader from '@/components/base/BaseListHeader.vue';
import BaseListItem from '@/components/base/BaseListItem.vue';
import PackageVariantIcon from 'vue-material-design-icons/PackageVariant.vue';
import Bullseye from 'vue-material-design-icons/Bullseye.vue';
import { namespace } from 'vuex-class';
import Domain from 'vue-material-design-icons/Domain.vue';

const profileModule = namespace('profile');
@Component({
    components: {
        AccountBoxOutlineIcon, AccountCircleOutlineIcon, AccountGroupOutlineIcon, BriefcaseOutlineIcon,
        CalendarOutlineIcon, ClipboardOutlineIcon, DollyIcon, EmailMultipleOutlineIcon, BaseListHeader, 
        BaseListItem, //BusinessIcon,
        CheckboxMarkedCircleOutlineIcon, ShapeOutlineIcon, ClipboardListOutlineIcon, PackageVariantIcon,
        Bullseye, FileDocumentOutlineIcon,
        Domain
    },
})
export default class CreateList extends Vue {
    @profileModule.Getter canCreateCustomer: any;
    @profileModule.Getter canCreateLead: any;
    @profileModule.Getter canCreateSupplier: any;


    @Emit('item-click')
    emitItemClick() {
        this.$root.$emit('toggleHamburgerMenu');
        return;
    }
}
